import { tracked } from "@glimmer/tracking";
import { preloadCategories } from "../lib/boards-categories.js";
import Column from "./column.js";

export default class Board {
  static async createPayload(data) {
    await Board.preloadCategories(data);

    return {
      ...data,
      board: Board.create(data.board),
      columns: (data.columns || []).map((column) => Column.create(column)),
    };
  }

  static create(args = {}) {
    if (args instanceof Board) {
      return args;
    }
    return new Board(args);
  }

  static preloadCategories({ board, columns = [] }) {
    return preloadCategories([
      ...(board.category_ids || []),
      ...columns.flatMap((column) => [
        column.move_to_category_id,
        ...(column.cards || []).map((card) => card.topic?.category_id),
      ]),
    ]);
  }

  @tracked anonymous_can_read;
  @tracked archived;
  @tracked can_archive;
  @tracked can_manage;
  @tracked can_unarchive;
  @tracked can_write;
  @tracked card_style;
  @tracked category_ids;
  @tracked columns;
  @tracked id;
  @tracked name;
  @tracked old_slug_used;
  @tracked require_confirmation;
  @tracked show_tags;
  @tracked show_topic_thumbnail;
  @tracked slug;
  @tracked tag_ids;
  @tracked tag_names;
  @tracked unicode_name;

  constructor(args = {}) {
    Object.assign(this, args);
    this.columns = (args.columns || []).map((column) => Column.create(column));
  }

  get canManage() {
    return !this.archived && this.can_manage;
  }

  get canWrite() {
    return !this.archived && this.can_write;
  }

  get fancyTitle() {
    return this.unicode_name || this.name;
  }
}
